import type { FC } from 'react';
import React from 'react';
import styled, { css } from 'styled-components';
import { Icon, GetColor } from 'venn-ui-kit';

export interface SplitButtonDropdownItemProps {
  label: React.ReactNode;
  tooltipContent?: string;
  icon?: string;
  onClick?: () => void;
}

const SplitButtonDropdownItemWrapper = styled.button<{ disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  width: 100%;
  white-space: nowrap;
  cursor: pointer;
  color: ${GetColor.Black};
  i {
    margin-right: 10px;
  }
  :hover {
    background: ${GetColor.GreyScale.Grey20};
    color: ${GetColor.Black};
  }
  ${(props) =>
    props.disabled &&
    css`
      :hover {
        background: transparent;
      }
    `}
`;

const SplitButtonDropdownItem: FC<React.PropsWithChildren<SplitButtonDropdownItemProps>> = ({
  label,
  icon,
  onClick,
}) => (
  <SplitButtonDropdownItemWrapper onClick={onClick} disabled={!onClick} className="split-item" tabIndex={0}>
    {icon && <Icon type={icon} />}
    {label}
  </SplitButtonDropdownItemWrapper>
);

export default SplitButtonDropdownItem;
